<template>
    <div class="wrapper blog__container">
        <div class="blog__container_banner">
            <img src="@/assets/img/blog/blog_hero_banner.png" alt="Blog Banner" class="blog__banner_image" />
            <h1 class="blog__banner_title">{{ $t('blog.banner_title') }}</h1>
        </div>
        <div class="blog__container_boxes">
            <div v-for="(post, index) in visiblePosts" :key="post.id" :class="getBoxClass(index)">
                <router-link :to="`/blog/post/${post.slug}`">
                    <div>
                        <h2 class="post__title">{{ post.title }}</h2>
                        <p class="post__description">{{ post.description }}</p>
                    </div>
                </router-link>
                <hr />
            </div>
        </div>
        <div class="blog__container_button">
            <button v-if="allPosts.length > 3 && !showAll" @click="toggleShowAll" class="blog__button">{{
                $t('blog.blog_button') }}</button>
        </div>
    </div>
</template>

<script setup>
import { getBlogCollection } from '@/assets/markdowns/blog/BlogCollection.js';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();
const showAll = ref(false);

const toggleShowAll = () => {
    showAll.value = !showAll.value;
};

const allPosts = computed(() => getBlogCollection(locale.value) || []);
const visiblePosts = computed(() => showAll.value ? allPosts.value : allPosts.value.slice(0, 3));

const getBoxClass = (index) => {
    const boxClass = [
        "blog__box blog__box__left",
        "blog__box",
        "blog__box blog__box__right"
    ];
    return boxClass[index % boxClass.length];
};
</script>

<style scoped>
.blog__container {
    display: flex;
    flex-direction: column;
    gap: 5rem;
    width: 100%;
    /* max-width: 1100px; */
    margin: 0 auto;
    /* height: 100%;
    min-height: 350px; */
    padding-top: 0 !important;
    padding-bottom: 8rem !important;
}

.blog__banner_image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 0 !important;
}

.blog__banner_title {
    position: absolute;
    width: inherit;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    font-size: 40px !important;
    font-weight: 800;
    text-align: center;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.blog__container_banner {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.blog__container_boxes {
    grid-template-columns: repeat(3, 1fr);
    display: grid;
    gap: 2rem;
    background-color: #f6faf3;
}



.post__title {
    font-size: 20px !important;
    font-weight: 800;
    line-height: 1.2;

}

.post__description {
    font-size: 12px !important;
    font-weight: 500;
    padding-bottom: 3rem;
}

.blog__container_boxes,
.blog__container_boxes div {
    border-radius: 25px;
}

.blog__box {
    grid-column: span 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    background-color: #f6faf3;
    padding: 30px 30px 10px 30px;
}

.blog__box__left {
    background-image: url('@/assets/img/blog/square-ticket-left.svg');
    background-position: right center;
    background-repeat: no-repeat;
    background-size: cover;
    padding: 30px 50px 10px 30px;
}

.blog__box__right {
    background-image: url('@/assets/img/blog/square-ticket-right.svg');
    background-position: left center;
    background-repeat: no-repeat;
    background-size: cover;
    padding: 30px 30px 10px 50px;
}

hr {
    width: 100%;
    border: 0;
    height: 1px;
    background-color: #1b3b46;
    margin: 2rem 0;
    align-self: flex-end;
}

.blog__box:hover {
    transform: scale(1.05);
    transition: all 0.3s ease-in-out;
}

.blog__container_button {
    display: flex;
    justify-content: center;
    margin: 2rem 0;
}

.blog__button {
    background-color: #f0da15;
    color: #1b3b46;
    border: none;
    border-radius: 13px;
    padding: 10px 20px;
    font-size: 16px;
    cursor: pointer;
    transition: background-color 0.3s ease;
    align-self: center;
}

.blog__button:hover {
    background-color: #1b3b46;
    color: #fff;
}

@media only screen and (max-width: 768px) {

    .blog__container_boxes {
        grid-template-columns: repeat(1, 1fr);
        padding-bottom: 1rem;
    }

    .blog__box:hover {
        transform: none;
        transition: none;
    }

    .blog__button {
        width: 100%;
        font-size: 2rem;
        padding: 20px 0;
        background: #1b3b46;
        color: #f6faf3;
    }

    .blog__button:hover {
        background: #f0da15;
        color: #1b3b46;
    }

    .blog__container_button {
        padding: var(--WrapperPadding);
        margin-bottom: 16rem;
    }

    .blog__banner_image {
        width: 100%;
        height: 20vh !important;
        object-fit: cover;
        border-radius: 0 0 48px 48px !important;
    }

    .blog__banner_title {
        font-size: 2.5rem !important;
    }
}
</style>